import React, { useState, useEffect } from 'react';
import {
  ArrowRight, Play, CheckCircle2, ChevronRight, BarChart3,
  Cpu, Globe, Shield, Zap, Star, Plus, Minus, Mail, Phone, MapPin,
  Layers, Code, Database, Fingerprint, Lock, Send, Hexagon,
  Users, Briefcase, TrendingUp, Network, Sparkles, MessageCircle,
  LayoutTemplate, Compass, ArrowUpRight, Wifi, X
} from 'lucide-react';
import { Link } from 'react-router-dom';
import SEO from './SEO';

import logo1 from '../assets/logo.png';
import logo2 from '../assets/logo.jpeg';
import logo3 from '../assets/4 LOGO.png';
import logo4 from '../assets/LOGO (1).png';
import logo5 from '../assets/Rajaram g Food company Registered logo..png';
import logo6 from '../assets/Rise institute sangli.jpg.jpeg';
import logo7 from '../assets/Sunsspark Industrries main logo for website.png';
import logo8 from '../assets/WhatsApp Image 2025-08-05 at 16.25.03_52ef6ae1.jpg.jpeg';
import logo9 from '../assets/WhatsApp Image 2026-06-15 at 12.25.29 PM.jpeg';
import logo10 from '../assets/img1.png';
import logo11 from '../assets/WhatsApp Image 2026-06-15 at 12.28.00 PM.jpeg';
import logo12 from '../assets/WhatsApp Image 2026-06-15 at 12.31.28 PM.jpeg';
import logo13 from '../assets/cropped-VersatileScientiest.jpg.jpeg';
import logo14 from '../assets/gargi collection logo.jpg.jpeg';
import logo15 from '../assets/pixel11_main_logo-removebg-preview.png';
import logo16 from '../assets/223542549_106464955065874_4432653023872989525_n.jpg.jpeg';
import logo17 from '../assets/ChatGPT Image Jun 10, 2026, 09_31_13 PM.png';
import brandImg from '../assets/Brand.jpeg';
import demoVideo from '../assets/vishwadigitech1.mp4';

import tm1 from '../assets/Anush.JPG.jpeg';
import tm2 from '../assets/sagar-bhosle.jpeg';
import tm3 from '../assets/sagar-patil.jpeg';
import tm4 from '../assets/sahil.jpeg';
import tm5 from '../assets/shubham.jpeg';
import tm6 from '../assets/sushant.jpeg';
import tm7 from '../assets/varad.png';

const AnimatedCounter = ({ target, suffix }) => {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const counterRef = React.useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    const currentRef = counterRef.current;
    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    const end = parseInt(target);
    const duration = 2000; // 2 seconds animation
    let startTime = null;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const percentage = Math.min(progress / duration, 1);

      // Easing function for smooth stop
      const easeOutQuart = 1 - Math.pow(1 - percentage, 4);
      setCount(Math.floor(end * easeOutQuart));

      if (percentage < 1) {
        requestAnimationFrame(animate);
      } else {
        setCount(end);
      }
    };

    requestAnimationFrame(animate);
  }, [target, isVisible]);

  return <span ref={counterRef}>{count}{suffix}</span>;
};

const HeroSection = () => {
  const [openFaq, setOpenFaq] = useState(0);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const dropdownRef = React.useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsServicesOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    countryCode: '+91',
    mobile: '',
    services: [],
    message: ''
  });

  const servicesList = [
    "Website Development",
    "Digital Marketing",
    "SEO & SEM",
    "Google Ads & Meta Ads Management",
    "Social Media Marketing",
    "Mobile App Development",
    "Custom Software Development",
    "Graphic Designing",
    "Video Editing & Content Creation"
  ];

  const handleServiceToggle = (service) => {
    setFormData(prev => {
      const isSelected = prev.services.includes(service);
      if (isSelected) {
        return { ...prev, services: prev.services.filter(s => s !== service) };
      } else {
        return { ...prev, services: [...prev.services, service] };
      }
    });
  };

  const handleWhatsAppSubmit = () => {
    const { firstName, lastName, email, countryCode, mobile, services, message } = formData;
    if (!firstName || !email || !mobile || !message || services.length === 0) {
      alert("Please fill in the required fields and select at least one service.");
      return;
    }
    if (mobile.length !== 10) {
      alert("Please enter a valid 10-digit mobile number.");
      return;
    }
    const servicesText = services.join(", ");
    const text = `Hello VishwaDigitech,\n\nNew contact form submission:\n*Name*: ${firstName} ${lastName}\n*Email*: ${email}\n*Mobile*: ${countryCode} ${mobile}\n*Services*: ${servicesText}\n*Message*: ${message}`;
    const encodedText = encodeURIComponent(text);
    const whatsappUrl = `https://wa.me/919699938509?text=${encodedText}`;
    window.open(whatsappUrl, '_blank');
  };

  // VDT Logo Theme Colors
  const theme = {
    bg: '#0A0F1F',         // Very dark blue background
    cardBg: '#0F1629',     // Slightly lighter blue for cards
    border: '#1E293B',     // Border color
    accent: '#0EA5E9',     // Cyan/Light Blue
    accentDark: '#0B2B5E'  // Deep Navy Blue
  };

  const gradientText = "bg-gradient-to-r from-[#0EA5E9] to-[#0B2B5E] bg-clip-text text-transparent";
  const gradientBg = "bg-gradient-to-r from-[#0EA5E9] to-[#0B2B5E]";
  const cardStyle = "bg-[#0F1629] border border-[#1E293B] rounded-3xl";

  const faqs = [
    { q: "How long does it take to implement your AI solutions?", a: "Implementation time varies depending on the complexity of your systems. Typically, a standard integration takes between 4 to 8 weeks from initial assessment to full deployment." },
    { q: "What industries do you primarily serve?", a: "We serve a wide range of industries including finance, healthcare, e-commerce, manufacturing, and education. Our AI models are highly adaptable." },
    { q: "How secure is the data processed by your AI?", a: "Security is our top priority. We use military-grade encryption, zero-trust architectures, and ensure full compliance with GDPR and HIPAA standards." },
    { q: "Can your solutions integrate with our legacy systems?", a: "Yes, we specialize in building custom API wrappers and middleware that allow our modern AI solutions to seamlessly communicate with legacy enterprise systems." },
    { q: "Do you provide ongoing support and maintenance?", a: "Absolutely. All our enterprise plans come with 24/7 dedicated support, continuous model training, and regular system health checks." }
  ];

  return (
    <>
      <SEO
        title="Digital Marketing & Web Development Company in Sangli"
        description="Vishwa DigiTech is Sangli's top digital marketing and web development company. We offer website design, mobile app development, SEO, social media marketing, WhatsApp API, graphic design & video production. Get a free quote today!"
        keywords="digital marketing sangli, web development sangli, website design sangli maharashtra, app development sangli, SEO company sangli, social media marketing india, vishwa digitech, IT company sangli"
        canonicalPath="/"
      />
      <style>{`
        @keyframes textRevealDrop {
          0% { opacity: 0; transform: translateY(-30px) scale(1.05); filter: blur(10px); }
          100% { opacity: 1; transform: translateY(0) scale(1); filter: blur(0px); }
        }
        @keyframes neonGlow {
          0%, 100% { filter: drop-shadow(0 0 15px rgba(14, 165, 233, 0.6)) drop-shadow(0 0 30px rgba(14, 165, 233, 0.4)); }
          50% { filter: drop-shadow(0 0 5px rgba(14, 165, 233, 0.3)) drop-shadow(0 0 10px rgba(14, 165, 233, 0.2)); }
        }
        @keyframes backgroundPan {
          0% { background-position: 0% center; }
          100% { background-position: -200% center; }
        }
        .hero-pro-reveal {
          animation: textRevealDrop 1.2s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
        }
        .hero-pro-reveal-delayed {
          opacity: 0;
          animation: textRevealDrop 1.2s cubic-bezier(0.2, 0.8, 0.2, 1) 0.3s forwards;
        }
        .hero-pro-gradient {
          background: linear-gradient(to right, #0EA5E9 20%, #7DD3FC 40%, #E0F2FE 50%, #7DD3FC 60%, #0EA5E9 80%);
          background-size: 200% auto;
          color: transparent;
          -webkit-background-clip: text;
          background-clip: text;
          animation: backgroundPan 4s linear infinite, neonGlow 3s ease-in-out infinite;
          display: inline-block;
        }
      `}</style>
      <div className="min-h-screen bg-[#0A0F1F] text-white overflow-x-hidden selection:bg-[#0EA5E9] selection:text-white" style={{ fontFamily: 'emoji' }}>

        {/* 1. HERO SECTION */}
        <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 px-4 sm:px-6 lg:px-8 border-b border-[#1E293B]">
          {/* Background Gradients & Video */}
          <div className="absolute inset-0 z-0 overflow-hidden bg-[#0A0F1F]">
            {/* YouTube Video Background with Blue Filter */}
            <div className="absolute w-[300vw] h-[300vh] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 md:w-[150vw] md:h-[150vh] lg:w-[120vw] lg:h-[120vh]">
              <iframe
                id="banner-video-background"
                frameBorder="0"
                allowFullScreen
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                title="Marko Video Background"
                className="w-full h-full pointer-events-none opacity-50 mix-blend-screen"
                style={{ filter: 'sepia(1) hue-rotate(190deg) saturate(300%) brightness(120%)' }}
                src="https://www.youtube.com/embed/P68V3iH4TeE?autoplay=1&controls=0&mute=1&loop=1&playlist=P68V3iH4TeE&showinfo=0&rel=0&disablekb=1&modestbranding=1&iv_load_policy=3"
              />
            </div>

            {/* Dark Overlay for readability (Keeps the background dark/blackish, not fully blue) */}
            <div className="absolute top-0 left-0 w-full h-full bg-[#0A0F1F]/80 z-10 pointer-events-none" />

            {/* Animated Glows */}
            <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#0EA5E9]/10 rounded-full blur-[120px] z-20 animate-pulse pointer-events-none" />
            <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#0EA5E9]/15 rounded-full blur-[120px] z-20 animate-pulse pointer-events-none" style={{ animationDelay: '2s' }} />
          </div>

          <div className="relative z-30 max-w-7xl mx-auto flex flex-col items-center text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-8 backdrop-blur-md">
              <Sparkles className="w-4 h-4" />
              Vishwa Digitech - Digital Solutions, Limitless Possibilities
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-[80px] font-extrabold leading-[1.1] mb-8 tracking-tight hero-pro-reveal">
              Empowering Business Through  <br className="hidden md:block" />
              <span className="hero-pro-gradient">Smart Digital Marketing & IT Solutions.</span>
            </h1>

            <p className="text-gray-400 text-lg md:text-xl max-w-3xl mb-12 leading-relaxed hero-pro-reveal-delayed">
              At Vishwa Digitech, we help startups, SMEs, and enterprises accelerate their growth through powerful digital marketing strategies and cutting-edge IT solutions.          </p>

            <div className="flex flex-col sm:flex-row items-center gap-4">
              <button className={`${gradientBg} text-white px-8 py-4 rounded-full font-bold tracking-wide flex items-center gap-2 hover:scale-105 transition-all shadow-[0_0_30px_rgba(14,165,233,0.3)]`}>
                Get Started Free <ArrowRight className="w-5 h-5" />
              </button>
              <button onClick={() => setIsVideoOpen(true)} className="px-8 py-4 rounded-full font-bold tracking-wide flex items-center gap-3 border border-white/20 hover:bg-white/10 transition-colors backdrop-blur-md">
                <div className="w-8 h-8 rounded-full bg-[#0EA5E9]/20 flex items-center justify-center">
                  <Play className="w-4 h-4 text-[#0EA5E9] ml-1" />
                </div>
                Watch Demo
              </button>
            </div>

            {/* Floating Element like in design */}
            {/* <div className="hidden lg:block absolute right-10 top-1/2 -translate-y-1/2 animate-[bounce_4s_infinite]">
            <div className="w-32 h-32 rounded-full border border-white/10 flex items-center justify-center backdrop-blur-xl bg-white/5 relative shadow-[0_0_50px_rgba(14,165,233,0.1)]">
               <div className="absolute inset-0 rounded-full border-t-2 border-[#0EA5E9] animate-spin" style={{ animationDuration: '3s' }} />
               <img src="https://cdn-icons-png.flaticon.com/512/2042/2042078.png" className="w-12 h-12 opacity-80 invert" alt="AI Icon" />
            </div>
          </div> */}
          </div>
        </section>

        {/* 2. ABOUT / FEATURES SECTION */}
        <section className="py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto relative z-20">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-6 backdrop-blur-md">
              <Sparkles className="w-4 h-4" />
              Our Identity
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black mb-6 tracking-tight">
              The Meaning Behind <br className="hidden md:block" />
              <span className="hero-pro-gradient">Our Brand</span>
            </h2>
            <p className="text-gray-400 max-w-3xl mx-auto text-lg md:text-xl leading-relaxed font-light">
              At Vishwa DigiTech, our logo represents more than just a brand—it reflects our vision and commitment to digital innovation and growth.
            </p>
          </div>

          <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-center">
            {/* Left side: Bento Grid Details */}
            <div className="lg:col-span-7 grid sm:grid-cols-2 gap-6 order-2 lg:order-1">

              {/* Card 1: Upward Arrow */}
              <div className="bg-white/[0.02] border border-white/5 p-8 rounded-3xl hover:bg-white/[0.05] hover:border-[#0EA5E9]/30 transition-all duration-500 group relative overflow-hidden flex flex-col justify-between">
                <div className="absolute top-0 right-0 w-32 h-32 bg-[#0EA5E9]/10 rounded-bl-full -z-10 group-hover:bg-[#0EA5E9]/20 transition-colors duration-500" />

                <div>
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#0EA5E9]/20 to-transparent border border-[#0EA5E9]/30 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-[0_0_20px_rgba(14,165,233,0.15)]">
                    <ArrowUpRight className="w-8 h-8 text-[#0EA5E9]" />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-[#0EA5E9] transition-colors">Upward Arrow</h3>
                  <p className="text-gray-400 leading-relaxed text-sm md:text-base">
                    The upward arrow symbolizes our commitment to helping businesses achieve continuous growth, improved performance, and long-term success through innovative digital marketing and IT solutions.                </p>
                </div>
              </div>

              {/* Card 2: Wi-Fi Signal */}
              <div className="bg-white/[0.02] border border-white/5 p-8 rounded-3xl hover:bg-white/[0.05] hover:border-[#06B6D4]/30 transition-all duration-500 group relative overflow-hidden flex flex-col justify-between">
                <div className="absolute top-0 right-0 w-32 h-32 bg-[#06B6D4]/10 rounded-bl-full -z-10 group-hover:bg-[#06B6D4]/20 transition-colors duration-500" />

                <div>
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#06B6D4]/20 to-transparent border border-[#06B6D4]/30 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:-rotate-6 transition-all duration-500 shadow-[0_0_20px_rgba(6,182,212,0.15)]">
                    <Wifi className="w-8 h-8 text-[#06B6D4]" />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-[#06B6D4] transition-colors">Wireless Signal</h3>
                  <p className="text-gray-400 leading-relaxed text-sm md:text-base">
                    The wireless signal reflects the power of the internet, digital connectivity, and modern technology. It represents our expertise in creating smart digital experiences that connect businesses with their customers worldwide.                </p>
                </div>
              </div>

              {/* Card 3: Quote */}
              <div className="sm:col-span-2 bg-gradient-to-br from-[#0EA5E9]/10 to-transparent border border-[#0EA5E9]/20 p-8 md:p-10 rounded-3xl relative overflow-hidden group">
                <div className="absolute -inset-2 bg-gradient-to-r from-[#0EA5E9]/0 via-[#0EA5E9]/10 to-[#0EA5E9]/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000 ease-in-out" />
                <p className="text-gray-300 font-medium leading-relaxed text-lg md:text-xl italic relative z-10">
                  <span className="text-4xl text-[#0EA5E9] absolute -top-4 -left-2 opacity-50">"</span>
                  <span className="pl-6 block">
                    Together, these elements represent Vishwa Digitech's commitment to driving business growth through innovation, technology, and seamless digital connectivity.                </span>
                </p>
              </div>

            </div>

            {/* Right side: Logo Image Display */}
            <div className="lg:col-span-5 relative order-1 lg:order-2">
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-gradient-to-tr from-[#0EA5E9]/20 to-[#1A4A8B]/30 rounded-full blur-3xl -z-10 animate-pulse" />

              <div className="relative group">
                <div className="absolute -inset-1 bg-gradient-to-r from-[#0EA5E9] to-[#06B6D4] rounded-[2.5rem] blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>
                <div className="relative bg-[#050810] border border-white/10 rounded-[2rem] overflow-hidden p-4">
                  <div className="relative rounded-[1.5rem] overflow-hidden">
                    <img src={brandImg} alt="Vishwa DigiTech Logo Meaning" className="w-full h-auto object-cover transform group-hover:scale-110 transition-transform duration-1000 ease-in-out" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0A0F1F]/80 via-[#0A0F1F]/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 3. SERVICES SECTION */}
        <section className="py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-4 backdrop-blur-md">
              <Sparkles className="w-4 h-4" />
              Our Expertise
            </div>
            <h2 className="text-4xl md:text-5xl font-bold">
              Transforming businesses with <br /> cutting-edge <span className="hero-pro-gradient">digital services</span>
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { icon: Globe, title: "Website Development", link: "/services/websites", desc: "Build highly responsive, fast, and secure websites tailored to your brand." },
              { icon: LayoutTemplate, title: "Application Development", link: "/services/apps", desc: "Custom iOS and Android applications with intuitive user experiences." },
              { icon: Code, title: "Custom Software Development", link: "/services/software", desc: "Scalable enterprise software solutions tailored to your unique workflows." },
              { icon: TrendingUp, title: "Digital Marketing", link: "/services/marketing", desc: "Data-driven marketing strategies to accelerate your business growth." },
              { icon: Zap, title: "Performance Marketing", link: "/services/marketing", desc: "Targeted ad campaigns designed for maximum ROI and lead generation." },
              { icon: MessageCircle, title: "Whatsapp API Development", link: "/services/whatsapp-api", desc: "Automated business messaging solutions for seamless communication." }
            ].map((srv, i) => (
              <Link to={srv.link} onClick={() => window.scrollTo(0, 0)} key={i} className={`${cardStyle} p-8 transition-all duration-500 ease-out hover:-translate-y-2 hover:shadow-[0_15px_40px_-10px_rgba(14,165,233,0.3)] hover:border-[#0EA5E9]/50 group cursor-pointer flex flex-col relative overflow-hidden block`}>
                {/* Shine effect background */}
                <div className="absolute inset-0 bg-gradient-to-br from-[#0EA5E9]/10 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />

                {/* Animated Border glow line at the top */}
                <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-[#0EA5E9] to-transparent opacity-0 group-hover:opacity-100 transform -translate-x-full group-hover:translate-x-0 transition-all duration-700 pointer-events-none" />

                <div className="relative z-10 flex flex-col h-full">
                  <div className="w-14 h-14 rounded-2xl bg-white/5 flex items-center justify-center mb-6 group-hover:bg-[#0EA5E9]/20 group-hover:scale-110 group-hover:-rotate-3 transition-all duration-500 border border-white/5 shadow-lg">
                    <srv.icon className="w-7 h-7 text-[#0EA5E9]" />
                  </div>
                  <h3 className="text-xl font-bold mb-3 group-hover:text-white text-gray-100 transition-colors duration-300">{srv.title}</h3>
                  <p className="text-gray-400 text-sm mb-6 leading-relaxed flex-grow group-hover:text-gray-300 transition-colors duration-300">{srv.desc}</p>
                  <div className="text-[#0EA5E9] flex items-center gap-2 text-sm font-bold opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-4 group-hover:translate-y-0 mt-auto">
                    Read More <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </section>

        {/* COUNTER / STATS SECTION (ULTRA MODERN) */}
        <section className="py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto relative z-30">
          <div className="relative rounded-[3rem] bg-[#0F1629]/60 backdrop-blur-3xl border border-white/10 shadow-[0_0_50px_rgba(14,165,233,0.1)] overflow-hidden">
            {/* Animated Background Gradients inside the panel */}
            <div className="absolute top-0 left-1/4 w-1/2 h-[2px] bg-gradient-to-r from-transparent via-[#0EA5E9] to-transparent opacity-50" />
            <div className="absolute bottom-0 right-1/4 w-1/2 h-[2px] bg-gradient-to-r from-transparent via-[#0EA5E9] to-transparent opacity-50" />
            <div className="absolute inset-0 bg-gradient-to-br from-[#0EA5E9]/5 via-transparent to-[#0B2B5E]/30 pointer-events-none" />

            <div className="grid grid-cols-2 lg:grid-cols-4 divide-y lg:divide-y-0 lg:divide-x divide-white/5 relative z-10">
              {[
                { number: "4", suffix: "+", label: "Years Experience", icon: Briefcase, color: "from-blue-400 to-cyan-300" },
                { number: "50", suffix: "+", label: "Projects Delivered", icon: Code, color: "from-cyan-400 to-teal-300" },
                { number: "100", suffix: "%", label: "Client Satisfaction", icon: Star, color: "from-amber-300 to-yellow-500" },
                { number: "10", suffix: "+", label: "Tech Experts", icon: Users, color: "from-purple-400 to-pink-400" }
              ].map((stat, idx) => (
                <div key={idx} className="p-10 lg:p-12 flex flex-col items-center justify-center group hover:bg-white/[0.03] transition-colors duration-500 cursor-pointer">
                  <div className="relative mb-6">
                    <div className={`absolute inset-0 bg-gradient-to-r ${stat.color} blur-[20px] opacity-0 group-hover:opacity-30 transition-opacity duration-500 rounded-full`} />
                    <div className="w-16 h-16 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center group-hover:scale-110 group-hover:-rotate-6 transition-all duration-500 shadow-xl relative z-10">
                      <stat.icon className="w-8 h-8 text-white group-hover:text-[#0EA5E9] transition-colors duration-300" />
                    </div>
                  </div>

                  <h3 className={`text-5xl md:text-6xl font-black mb-2 tracking-tighter bg-clip-text text-transparent bg-gradient-to-b from-white to-gray-500 group-hover:from-white group-hover:to-white transition-all duration-500 group-hover:scale-105`}>
                    <AnimatedCounter target={stat.number} suffix={stat.suffix} />
                  </h3>
                  <p className="text-gray-400 font-bold uppercase tracking-widest text-xs md:text-sm text-center group-hover:text-[#0EA5E9] transition-colors duration-300 mt-2">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* MARQUEE SECTION */}
        <div className="border-b border-[#1E293B] bg-[#0A0F1F] py-16 overflow-hidden relative z-20 flex flex-col">
          <div className="text-center mb-12 w-full">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase backdrop-blur-md">
              <Sparkles className="w-4 h-4" />
              Our Valuable Clients
            </div>
          </div>
          <div className="animate-marquee flex w-max">
            {/* We use 4 sets so it fills even large screens and translates seamlessly by 50% */}
            {[1, 2, 3, 4].map((set) => (
              <div key={set} className="flex gap-16 md:gap-32 items-center justify-center px-8 md:px-16 shrink-0">
                <img src={logo1} alt="VDT Vishwadigitech" className="h-16 md:h-24 object-contain hover:scale-110 transition-transform duration-300 drop-shadow-xl" />
                <img src={logo2} alt="Anusaya Hospital" className="h-16 md:h-24 object-contain hover:scale-110 transition-transform duration-300 drop-shadow-xl" />
                <img src={logo3} alt="O24" className="h-16 md:h-24 object-contain hover:scale-110 transition-transform duration-300 drop-shadow-xl" />
                <img src={logo4} alt="Client Logo 4" className="h-16 md:h-24 object-contain hover:scale-110 transition-transform duration-300 drop-shadow-xl" />
                <img src={logo5} alt="Rajaram Food Company" className="h-16 md:h-24 object-contain hover:scale-110 transition-transform duration-300 drop-shadow-xl" />
                <img src={logo6} alt="Rise Institute Sangli" className="h-16 md:h-24 object-contain hover:scale-110 transition-transform duration-300 drop-shadow-xl" />
                <img src={logo7} alt="Sunsspark Industries" className="h-16 md:h-24 object-contain hover:scale-110 transition-transform duration-300 drop-shadow-xl" />
                <img src={logo8} alt="Client Logo 8" className="h-16 md:h-24 object-contain hover:scale-110 transition-transform duration-300 drop-shadow-xl" />
                <img src={logo9} alt="Client Logo 9" className="h-16 md:h-24 object-contain hover:scale-110 transition-transform duration-300 drop-shadow-xl" />
                <img src={logo10} alt="Client Logo 10" className="h-16 md:h-24 object-contain hover:scale-110 transition-transform duration-300 drop-shadow-xl" />
                <img src={logo11} alt="Client Logo 11" className="h-16 md:h-24 object-contain hover:scale-110 transition-transform duration-300 drop-shadow-xl" />
                <img src={logo12} alt="Client Logo 12" className="h-16 md:h-24 object-contain hover:scale-110 transition-transform duration-300 drop-shadow-xl" />
                <img src={logo13} alt="Versatile Scientist" className="h-16 md:h-24 object-contain hover:scale-110 transition-transform duration-300 drop-shadow-xl" />
                <img src={logo14} alt="Gargi Collection" className="h-16 md:h-24 object-contain hover:scale-110 transition-transform duration-300 drop-shadow-xl" />
                <img src={logo15} alt="Pixel11" className="h-16 md:h-24 object-contain hover:scale-110 transition-transform duration-300 drop-shadow-xl" />
                <img src={logo16} alt="Client Logo 16" className="h-16 md:h-24 object-contain hover:scale-110 transition-transform duration-300 drop-shadow-xl" />
                <img src={logo17} alt="ChatGPT Logo" className="h-16 md:h-24 object-contain hover:scale-110 transition-transform duration-300 drop-shadow-xl" />
              </div>
            ))}
          </div>
        </div>

        {/* MEET OUR TEAM SECTION */}
        <section className="py-24 border-t border-[#1E293B] relative z-20 overflow-hidden">
          <div className="text-center mb-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-4 backdrop-blur-md">
              <Sparkles className="w-4 h-4" />
              Our Team
            </div>
            <h2 className="text-4xl md:text-5xl font-bold">
              Meet the minds behind <br /> our <span className="hero-pro-gradient">innovative solutions</span>
            </h2>
          </div>

          {/* Team Slider Container */}
          <div className="flex w-max animate-marquee hover:[animation-play-state:paused] py-4">
            {[1, 2, 3, 4].map((set) => (
              <div key={set} className="flex gap-6 sm:gap-8 px-3 sm:px-4 shrink-0">
                {[
                  { name: "Anush Bhosale", role: "Social Media Head", img: tm1 },
                  { name: "Sagar Bhosale", role: "Web Development", img: tm2 },
                  { name: "Sagar Patil", role: "Android Development", img: tm3 },
                  { name: "Sahil Jadhav", role: "Web Development", img: tm4 },
                  { name: "Shubham Mali", role: "Web Development", img: tm5 },
                  { name: "Sushant Chougule", role: "Android Development", img: tm6 },
                  { name: "Varad Aute", role: "Project Head", img: tm7 }
                ].map((member, i) => (
                  <div key={i} className="group relative rounded-3xl overflow-hidden bg-[#0F1629] border border-[#1E293B] shadow-lg hover:shadow-[0_0_40px_rgba(14,165,233,0.15)] transition-all duration-500 hover:-translate-y-2 cursor-pointer w-[280px] sm:w-[260px] shrink-0">
                    <div className="relative h-[20rem] overflow-hidden bg-[#1E293B]">
                      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0F1F] via-[#0EA5E9]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10" />
                      <img src={member.img} alt={member.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 grayscale group-hover:grayscale-0" />

                      {/* Social Links sliding up */}
                      <div className="absolute bottom-6 left-0 w-full flex justify-center gap-3 translate-y-12 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 z-20">
                        {['Instagram', 'LinkedIn'].map(social => (
                          <a
                            key={social}
                            href={social === 'Instagram' ? "https://www.instagram.com/vishwadigitech?igsh=c3M2cWs0cXV2bmJz" : "https://www.linkedin.com/company/vishwa-digitech"}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-10 h-10 rounded-full bg-black/50 backdrop-blur-md border border-white/20 flex items-center justify-center hover:bg-[#0EA5E9] hover:border-[#0EA5E9] transition-all duration-300 text-white hover:scale-110 shadow-lg"
                          >
                            {social === 'Instagram' && <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" /></svg>}
                            {social === 'LinkedIn' && <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" /></svg>}
                          </a>
                        ))}
                      </div>
                    </div>
                    <div className="p-6 relative bg-[#0F1629]">
                      <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-[#0EA5E9] to-[#0B2B5E] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
                      <h3 className="text-xl font-bold mb-1 group-hover:text-[#0EA5E9] transition-colors duration-300">{member.name}</h3>
                      <p className="text-sm text-gray-400 font-medium">{member.role}</p>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </section>

        {/* CONTACT US SECTION */}
        <section className="py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto border-t border-[#1E293B]">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-4 backdrop-blur-md">
              <Sparkles className="w-4 h-4" />
              Contact Us
            </div>
            <h2 className="text-4xl md:text-5xl font-bold">
              Let's build something <br /> <span className="hero-pro-gradient">extraordinary together</span>
            </h2>
          </div>

          <div className="grid lg:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div className="space-y-6">
              <div className="group relative rounded-3xl overflow-hidden bg-[#0F1629] border border-[#1E293B] p-8 hover:shadow-[0_0_40px_rgba(14,165,233,0.15)] transition-all duration-500">
                <div className="absolute inset-0 bg-gradient-to-r from-[#0EA5E9]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                <div className="w-14 h-14 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500">
                  <Mail className="w-6 h-6 text-[#0EA5E9]" />
                </div>
                <h3 className="text-2xl font-bold mb-2">Email Us</h3>
                <p className="text-gray-400 mb-4">Have a project in mind or need expert guidance? We're just an email away.</p>
                <a href="mailto:info@vishwadigitech.com" className="text-[#0EA5E9] font-medium hover:underline flex items-center gap-2">info@vishwadigitech.com <ArrowRight className="w-4 h-4" /></a>
              </div>

              <div className="group relative rounded-3xl overflow-hidden bg-[#0F1629] border border-[#1E293B] p-8 hover:shadow-[0_0_40px_rgba(14,165,233,0.15)] transition-all duration-500">
                <div className="absolute inset-0 bg-gradient-to-r from-[#0EA5E9]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                <div className="w-14 h-14 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500">
                  <Phone className="w-6 h-6 text-[#0EA5E9]" />
                </div>
                <h3 className="text-2xl font-bold mb-2">Call Us</h3>
                <p className="text-gray-400 mb-4">Monday - Friday from 9am to 6pm.</p>
                <a href="tel:+919699938509" className="text-[#0EA5E9] font-medium hover:underline flex items-center gap-2">+91 9699938509 <ArrowRight className="w-4 h-4" /></a>
              </div>

              <div className="group relative rounded-3xl overflow-hidden bg-[#0F1629] border border-[#1E293B] p-8 hover:shadow-[0_0_40px_rgba(14,165,233,0.15)] transition-all duration-500">
                <div className="absolute inset-0 bg-gradient-to-r from-[#0EA5E9]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                <div className="w-14 h-14 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500">
                  <MapPin className="w-6 h-6 text-[#0EA5E9]" />
                </div>
                <h3 className="text-2xl font-bold mb-2">Visit Us</h3>
                <p className="text-gray-400 mb-4">Come say hello at our office HQ.</p>
                <p className="text-[#0EA5E9] font-medium">Sangli, Maharashtra, India</p>
              </div>
            </div>

            {/* Contact Form */}
            <div className="relative rounded-3xl overflow-hidden bg-[#0F1629] border border-[#1E293B] p-8 md:p-12 shadow-2xl h-full flex flex-col justify-center">
              <div className="absolute inset-0 bg-gradient-to-br from-[#0EA5E9]/5 via-transparent to-transparent pointer-events-none" />
              <div className="relative z-10">
                <h3 className="text-3xl font-bold mb-8">Send us a message</h3>
                <form className="space-y-6">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div className="space-y-2">
                      <label className="text-sm font-medium text-gray-300">First Name</label>
                      <input type="text" placeholder="Enter Your First Name" value={formData.firstName} onChange={(e) => setFormData({ ...formData, firstName: e.target.value })} className="w-full bg-[#1E293B] border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#0EA5E9] transition-colors" />
                    </div>
                    <div className="space-y-2">
                      <label className="text-sm font-medium text-gray-300">Last Name</label>
                      <input type="text" placeholder="Enter Your Last Name" value={formData.lastName} onChange={(e) => setFormData({ ...formData, lastName: e.target.value })} className="w-full bg-[#1E293B] border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#0EA5E9] transition-colors" />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div className="space-y-2">
                      <label className="text-sm font-medium text-gray-300">Email Address</label>
                      <input type="email" placeholder="Enter Your Email Address" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} className="w-full bg-[#1E293B] border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#0EA5E9] transition-colors" />
                    </div>
                    <div className="space-y-2">
                      <label className="text-sm font-medium text-gray-300">Mobile Number</label>
                      <div className="flex bg-[#1E293B] border border-white/10 rounded-xl overflow-hidden focus-within:border-[#0EA5E9] transition-colors">
                        <select
                          value={formData.countryCode}
                          onChange={(e) => setFormData({ ...formData, countryCode: e.target.value })}
                          className="bg-transparent text-sm text-gray-300 border-none outline-none pl-2 pr-1 py-3 cursor-pointer w-[90px]"
                        >
                          <option value="+91" className="bg-[#0F1629] text-white">IN (+91)</option>
                          <option value="+1" className="bg-[#0F1629] text-white">US (+1)</option>
                          <option value="+44" className="bg-[#0F1629] text-white">UK (+44)</option>
                          <option value="+971" className="bg-[#0F1629] text-white">UAE (+971)</option>
                          <option value="+61" className="bg-[#0F1629] text-white">AU (+61)</option>
                        </select>
                        <input
                          type="tel"
                          placeholder="Mobile No"
                          value={formData.mobile}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '');
                            if (value.length <= 10) {
                              setFormData({ ...formData, mobile: value });
                            }
                          }}
                          className="w-full bg-transparent border-none outline-none px-4 py-3 text-white"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="space-y-2 relative" ref={dropdownRef}>
                    <label className="text-sm font-medium text-gray-300">Our Services</label>
                    <div
                      className="w-full bg-[#1E293B] border border-white/10 rounded-xl px-4 py-3 text-white cursor-pointer flex justify-between items-center transition-colors hover:border-white/20"
                      onClick={() => setIsServicesOpen(!isServicesOpen)}
                    >
                      <span className={formData.services.length === 0 ? "text-gray-400" : "text-white"}>
                        {formData.services.length === 0 ? "Select Services" : `${formData.services.length} services selected`}
                      </span>
                      <ChevronRight className={`w-4 h-4 transition-transform duration-300 ${isServicesOpen ? 'rotate-90 text-[#0EA5E9]' : 'text-gray-400'}`} />
                    </div>

                    {isServicesOpen && (
                      <div className="absolute z-50 w-full mt-2 bg-[#0F1629] border border-white/10 rounded-xl shadow-[0_10px_40px_rgba(0,0,0,0.5)] max-h-60 overflow-y-auto">
                        <div className="p-2 space-y-1">
                          {servicesList.map((service, idx) => (
                            <label key={idx} className="flex items-center gap-3 p-3 rounded-lg hover:bg-white/5 cursor-pointer transition-colors">
                              <input
                                type="checkbox"
                                className="w-4 h-4 rounded border-gray-500 text-[#0EA5E9] focus:ring-[#0EA5E9] bg-[#1E293B] cursor-pointer"
                                checked={formData.services.includes(service)}
                                onChange={() => handleServiceToggle(service)}
                              />
                              <span className="text-sm text-gray-300">{service}</span>
                            </label>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-300">Message</label>
                    <textarea rows="4" placeholder="How can we help you?" value={formData.message} onChange={(e) => setFormData({ ...formData, message: e.target.value })} className="w-full bg-[#1E293B] border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#0EA5E9] transition-colors resize-none"></textarea>
                  </div>
                  <button type="button" onClick={handleWhatsAppSubmit} className={`w-full ${gradientBg} text-white px-8 py-4 rounded-xl font-bold tracking-wide flex items-center justify-center gap-2 hover:scale-[1.02] transition-transform shadow-lg`}>
                    Send Message <Send className="w-4 h-4" />
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* VIDEO POPUP MODAL */}
        {isVideoOpen && (
          <div
            className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-md p-4 md:p-8"
            onClick={() => setIsVideoOpen(false)}
          >
            <div
              className="relative w-full max-w-6xl max-h-[90vh] rounded-2xl overflow-hidden bg-[#0A0F1F] border border-white/10 shadow-[0_0_80px_rgba(14,165,233,0.2)] animate-text-reveal flex items-center justify-center"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setIsVideoOpen(false)}
                className="absolute top-4 right-4 z-50 w-12 h-12 rounded-full bg-black/60 border border-white/20 flex items-center justify-center text-white hover:bg-red-500 hover:scale-110 transition-all shadow-lg"
              >
                <X className="w-6 h-6" />
              </button>
              <video
                src={demoVideo}
                controls
                autoPlay
                className="w-full h-full max-h-[90vh] object-contain rounded-xl"
              />
            </div>
          </div>
        )}

      </div>
    </>
  );
};

export default HeroSection;